module.exports = __webpack_public_path__ + "img/ic_age_verified.edd5000d.png";